module.exports = __webpack_public_path__ + "img/1498857570.f0a6e560.jpg";